import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// App
// Must come first: declares the cascade layer order so Bootstrap's reset ranks
// below PrimeReact v10's themed components (which live in @layer primereact).
import "./assets/sass/layers.css";
import "primereact/resources/themes/bootstrap4-light-purple/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./index.sass";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Translations
import en from "./assets/i18n/en-US.json";
import es from "./assets/i18n/es-ES.json";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { getBrowserLang } from "./services/i18n/i18n.service";
import { locale, addLocale } from "primereact/api";
import { ThemeProvider } from "./contexts/Theme.context";
import { applyThemeToDocument, getStoredTheme } from "./services/theme/theme.service";

// Apply the persisted theme to <html> before React mounts, so there is no
// flash of the wrong theme on first paint.
applyThemeToDocument(getStoredTheme());

// i18n: Internationalization
i18next.init({
	interpolation: { escapeValue: false }, // React already does escaping
	lng: getBrowserLang(), // language to use
	fallbackLng: "en",
	supportedLngs: ["en", "es"],
	resources: {
		en: {
			common: en,
		},
		es: {
			common: es,
		},
	},
});

// Primereact: add translations used internally by some components (calendar, table, etc.)
addLocale("es", es.UI_COMPONENTS.PRIME_REACT);

// Use the browser language. Otherwise use the fallback language ('en')
locale(!i18next.languages.includes(i18next.language) ? "en" : i18next.language);

// Render primary component
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	//<React.StrictMode> {/* Makes every component instantiate twice */}
	<I18nextProvider i18n={i18next}>
		<ThemeProvider>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</ThemeProvider>
	</I18nextProvider>
	// </React.StrictMode>
);

reportWebVitals();
